import React, { useEffect, useState } from "react";
import { COLORS, PERSONAL } from "../data/profile";
import { useLang, t } from "../LanguageContext";

export default function Hero() {
  const { lang, toggle } = useLang();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const tagline = PERSONAL.tagline;

  return (
    <section
      className="hero-section"
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        background: `linear-gradient(165deg, ${COLORS.dark} 0%, #1A2A3A 45%, ${COLORS.secondary} 100%)`,
        color: "#F5F0EB",
        padding: "0 24px",
        paddingTop: "env(safe-area-inset-top, 0)",
      }}
    >
      {/* Dot pattern */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.03,
          backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
          backgroundSize: "28px 28px",
          pointerEvents: "none",
          transform: `translate3d(0, ${scrollY * 0.3}px, 0)`,
        }}
      />

      {/* Language toggle */}
      <button
        onClick={toggle}
        aria-label={lang === "en" ? "Switch to French" : "Switch to English"}
        className="lang-toggle"
      >
        {lang === "en" ? "FR" : "EN"}
      </button>

      <div style={{ maxWidth: 680, width: "100%", textAlign: "center", position: "relative", zIndex: 2 }}>
        {/* Photo with parallax */}
        <div
          style={{
            transform: `translate3d(0, ${scrollY * -0.15}px, 0)`,
            marginBottom: 32,
          }}
        >
          <img
            src={PERSONAL.photo}
            alt={PERSONAL.name}
            className="hero-photo"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        </div>

        <h1 className="hero-name">{PERSONAL.name}</h1>
        <p className="hero-tagline">{t(tagline, lang)}</p>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M7 13l5 5 5-5M7 6l5 5 5-5" />
        </svg>
      </div>
    </section>
  );
}
